import { useEffect } from 'react';

import { useRouter } from 'next/router';

import { createFacebookPageViewEvent } from '@/common/analytics/facebookPixel/createFacebookPageViewEvent';
import { ConfigPublic } from '@/common/config.public';

export const FacebookPixel = () => {
  const router = useRouter();

  useEffect(() => {
    if (!ConfigPublic.FbPixelId) return;

    // This pageview only triggers the first time (it's important for Pixel to have real information)
    createFacebookPageViewEvent();

    router.events.on('routeChangeComplete', createFacebookPageViewEvent);
    return () => {
      router.events.off('routeChangeComplete', createFacebookPageViewEvent);
    };
  }, [router.events]);

  return null;
};
